import React from 'react';
import ProjectCard from '../components/ProjectCard';
import { useProjects } from '../context/ProjectsContext';
import MainLayout from '../layouts/MainLayout';

const ProjectsPage: React.FC = () => {
  const { projects, loading, error } = useProjects();

  return (
    <MainLayout>
      <div className="atlas-page">
        <div className="atlas-page-heading">
          <span className="atlas-kicker">ПОРТФОЛИО</span>
          <h1>Проекты и инструменты<span className="atlas-punctuation">.</span></h1>
          <p>Небольшие продукты и эксперименты, которые помогают решать реальные задачи.</p>
        </div>
        {loading ? (
          <div className="atlas-loading" aria-live="polite">Загрузка проектов…</div>
        ) : error ? (
          <div className="atlas-notice" role="status">{error}</div>
        ) : projects.length ? (
          <div className="atlas-project-grid">{projects.map((project) => <ProjectCard key={project.id} project={project} />)}</div>
        ) : (
          <div className="atlas-notice">Нет проектов для отображения.</div>
        )}
      </div>
    </MainLayout>
  );
};

export default ProjectsPage;
